import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { Templates_Get_All, Templates_Initialize } from "../api/API_Templates";
import { Context_UI } from "./Context_UI";
import App_Properties from "../Assets/Resource_Files/App_Properties";

const Context_Status_Global = createContext();

export default function Context_Provider_Status_Global({ children }) {
    const [List_Unsaved, List_Unsaved_Set] = useState([]);
    const [Status_Saving, Status_Saving_Set] = useState("None");
    const [Status_Fetching, Status_Fetching_Set] = useState("None");
    const [Status_Refresh, Status_Refresh_Set] = useState(0);
    // const [Slide_Active, Slide_Active_Set] = useState(null);
    const [DR_Templates_List, DR_Templates_List_Set] = useState([]);
    const navigate = useNavigate();
    const Location = useLocation();
    const Slide_Active = Location.pathname;
    const [Slide_Previous, Slide_Previous_Set] = useState(null);
    const [Panel_Left_State, Panel_Left_State_Set] = useState("Expanded");
    const [Panel_Right_State, Panel_Right_State_Set] = useState("Expanded");
    const [Panel_Center_State, Panel_Center_State_Set] = useState(null);
    const [Status_Delete, Status_Delete_Set] = useState("None");
    const Ref_WaitingFor_Delete = useRef(null);
    const UI = useContext(Context_UI);
    const [App_Properties_Master, App_Properties_Master_Set] = useState(App_Properties);

    const [Progress, Progress_Set] = useState({
        State: "Ready",
        Count_Total: 0,
        Count_Current: 0,
        Percent_Current: 0.0
    });


    const [Page_Properties, Page_Properties_Set] = useState({
        "Panels": {
            "Left": {
                "Enabled": false,
                "State": "Collapsed",
                "Title": "Panel left",
                "Toggle": false,
                "Width": {
                    "Expanded": "0px",
                    "Collapsed": "0px"
                }
            },
            "Center": {
                "Margins": false
            },
            "Right": {
                "Enabled": false,
                "State": "Collapsed",
                "Title": "Today",
                "Toggle": false,
                "Width": {
                    "Expanded": "0px",
                    "Collapsed": "0px"
                }
            }
        },
        "Ribbon": {
            "Enabled": false
        },
        "Properties": {
            "Header_Title": "...",
            "Trigger_LoadingScreen": false,
            "Window": {
                "Title": {
                    "Primary": "Digi-Rooms",
                    "Secondary": "",
                    "Separator": ""
                }
            }
        }
    });

    useEffect(() => {
        if (Status_Saving == "Success") {
            setTimeout(function () {
                Status_Saving_Set("None");
            }, 3000);
        }
    }, [Status_Saving]);

    useEffect(() => {
        if (Status_Fetching == "Success") {
            setTimeout(function () {
                Status_Fetching_Set("None");
            }, 3000);
        }
    }, [Status_Fetching]);

    const Data_Refresh = async () => {
        Status_Refresh_Set(Status_Refresh => Status_Refresh + 1);
    }


    const Data_Reload = async (Type) => {
        if (Type == "Templates_List") {
            await Templates_Load();
        }
    }

    const Templates_Load = async () => {
        const Response = await Templates_Get_All();
        if (Response.data.length == 0) {
            console.warn("Empty response");
            await Templates_Initialize()
                .catch(Error => {
                    if (Error.response && Error.response.status === 409) {
                        console.info("Skip.");
                    } else {
                        console.error("Error.");
                    }
                });
            const Response_Retry = await Templates_Get_All();
            DR_Templates_List_Set(Response_Retry.data);
            window.Toasts_CreateToast("https://elmerf5445.github.io/Digi-Rooms-Status/Assets/Icons/favicon.png", "Template initialized", "It worked.");
        } else {
            DR_Templates_List_Set(Response.data);
            // window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "Template loaded", "It worked.");
        }
    }

    useEffect(() => {
        Set();
    }, []);

    const Set = async () => {
        // await UI.Initialize();
        // UI.Slide_Properties_Set(Slide_Active);
    }


    const Slide_Switch = async (Path) => {
        
        // Slide_Active_Set(Path);
    }

    const Panel_Toggle = (Side) => {
        const Current_State = Page_Properties.Panels[Side].State || "Expanded";
        const New_State = Current_State === "Expanded" ? "Collapsed" : "Expanded";
        const Update_Page = {
            ...Page_Properties,
            Panels: {
                ...Page_Properties.Panels,
                [Side]: {
                    ...Page_Properties.Panels[Side],
                    State: New_State
                }
            }
        };

        Page_Properties_Set(Update_Page);

        App_Properties_Master_Set((Previous) =>
            Previous.map((item) =>
                item.Slide_ID === Update_Page.Slide_ID
                    ? { ...item, Panels: Update_Page.Panels }
                    : item
            )
        );
    }

    useEffect(() => {
        const Update_Page = {
            ...Page_Properties,
            Panels: {
                ...Page_Properties.Panels,
                Left: {
                    ...Page_Properties.Panels.Left,
                    State: Panel_Left_State
                },
                Right: {
                    ...Page_Properties.Panels.Right,
                    State: Panel_Right_State
                }
            }
        };

        Page_Properties_Set(Update_Page);

        App_Properties_Master_Set((Previous) =>
            Previous.map((item) =>
                item.Slide_ID === Update_Page.Slide_ID
                    ? { ...item, Panels: Update_Page.Panels }
                    : item
            )
        );
    }, [Panel_Left_State, Panel_Right_State])

    useEffect(() => {
        if (Page_Properties.Panels.Left.Enabled) {
            Panel_Left_State_Set(Page_Properties.Panels.Left.State);
        } else {
            Panel_Left_State_Set("Disabled");
        }

        if (Page_Properties.Panels.Right.Enabled) {
            Panel_Right_State_Set(Page_Properties.Panels.Right.State);
        } else {
            Panel_Right_State_Set("Disabled");
        }

    }, [Page_Properties]);

    const Unsaved_Add = (Value) => {
        if (!List_Unsaved.includes(Value)) {
            List_Unsaved_Set(prev => [...prev, Value]);
        }
    }

    const Unsaved_Remove = (Value) => {
        if (List_Unsaved.includes(Value)) {
            List_Unsaved_Set(prev => prev.filter(Item => Item !== Value));
        }
    }

    const Unsaved_Remove_All = () => {
        List_Unsaved_Set([]);
    }

    const Unsaved_Clear = async (Value) => {

        if (List_Unsaved.length > 0 && List_Unsaved.includes(Value)) {
            const { Response } = await Confirmer_Confirm("Window_General_UnsavedChanges");
            if (Response === "Confirmed") { // Discard changes
                Unsaved_Remove(Value);
                return true;
            } else if (Response === "Rejected") { // Cancel
                return false;
            }
            console.error("UNSAVED");
            return false;
        } else {
            return true;
        }
    }

    const Unsaved_Check = async () => {
        // Check if there are ANY unsaved changes
        if (List_Unsaved.length > 0) {

            const { Response } = await Confirmer_Confirm("Window_General_UnsavedChanges");

            if (Response === "Confirmed") {
                // User confirmed to discard, so clear ALL unsaved changes
                Unsaved_Remove_All();
                return true; // Return true to proceed with the original action
            } else if (Response === "Rejected") {
                return false; // Return false to stop the original action
            }

            // Handle any other unexpected response
            console.error("UNSAVED: Unexpected response from Confirmer_Confirm");
            return false;
        } else {
            // No unsaved changes, so it's safe to proceed
            return true;
        }
    }

    const Delete_Confirm = (ID) => {

        if (Ref_WaitingFor_Delete.current) {
            return Promise.resolve(false);
        }

        return new Promise((Resolve) => {
            Ref_WaitingFor_Delete.current = Resolve;
            Status_Delete_Set("Confirming");
            UI.Subwindows_Open(ID);
        })
    }

    const Delete_Respond = (Confirmed, Window_Close = true, ID = null) => {
        const Resolver = Ref_WaitingFor_Delete.current;
        if (!Resolver) {
            console.warn("No delete to respond to.");
            return;
        }

        Resolver(!!Confirmed);
        Ref_WaitingFor_Delete.current = null;

        Status_Delete_Set(Confirmed ? "Confirmed" : "");
        if (Window_Close && ID) {
            UI.Subwindows_Close(ID);
        }

    }

    const Ref_WaitingFor_Confirmer = useRef(null);
    const [Status_Confirming, Status_Confirming_Set] = useState("");

    const Confirmer_Confirm = (ID) => {
        if (Ref_WaitingFor_Confirmer.current) {
            return Promise.resolve({ Response: "Rejected", Data: {} });
        }

        return new Promise((Resolve) => {
            Ref_WaitingFor_Confirmer.current = Resolve;
            Status_Confirming_Set("Confirming");
            UI.Subwindows_Open(ID);
        })
    }

    const Confirmer_Respond = (Confirmed, Data, Window_Close = true, ID = null) => {
        const Resolver = Ref_WaitingFor_Confirmer.current;
        if (!Resolver) {
            console.warn("No confirmer to respond to.");
            return;
        }

        Resolver({ Response: Confirmed ? "Confirmed" : "Rejected", Data });
        Ref_WaitingFor_Confirmer.current = null;

        Status_Confirming_Set(Confirmed ? "Confirmed" : "");
        if (Window_Close && ID) {
            UI.Subwindows_Close(ID);
        }
    }

    const [App_Navigation, App_Navigation_Set] = useState(null);
    

    useEffect(() => {
        const Load_Navigation = (Data) => {
            // window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "Loaded navigation", "It worked.");
            App_Navigation_Set(Data);
        }
        UI.on("App_Navigation_Loaded", Load_Navigation);
        return () => {
            UI.off("App_Navigation_Loaded", Load_Navigation);
        }
    }, []);


    const breakpoint = 1000;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
        if (!Page_Properties) return;
        
        if (isMobile) {
            // console.error("UPDATED");
            if (Page_Properties.Panels.Left.Enabled && Page_Properties.Panels.Left.State === "Expanded") {
                Panel_Toggle("Left");
            }
            if (Page_Properties.Panels.Right.Enabled && Page_Properties.Panels.Right.State === "Expanded") {
                Panel_Toggle("Right");
            }
        }
    }, [isMobile, Location.pathname]);

    useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth <= breakpoint);
        window.addEventListener("resize", handler);
        return () => window.removeEventListener("resize", handler);
    }, []);

    const [Location_Last, Location_Last_Set] = useState(null);

    const Navigate = (Path) => {
        Location_Last_Set(Location.pathname);
        navigate(Path);
    }
    return (
        <Context_Status_Global.Provider value={{
            List_Unsaved,
            List_Unsaved_Set,
            Status_Saving,
            Status_Saving_Set,
            Status_Fetching,
            Status_Fetching_Set,
            DR_Templates_List,
            Data_Refresh,
            Status_Refresh,
            Slide_Active,
            Slide_Switch,
            Slide_Previous,
            Slide_Previous_Set,
            Panel_Left_State,
            Panel_Left_State_Set,
            Panel_Right_State,
            Panel_Right_State_Set,
            Panel_Center_State,
            Panel_Toggle,
            Unsaved_Clear,
            Unsaved_Add,
            Unsaved_Remove,
            Unsaved_Remove_All,
            Unsaved_Check,
            Delete_Confirm,
            Delete_Respond,
            Status_Delete,
            Status_Confirming,
            Confirmer_Confirm,
            Confirmer_Respond,
            Page_Properties,
            Page_Properties_Set,
            App_Properties_Master,
            Location,
            Location_Last,
            Navigate,
            Progress,
            Progress_Set

        }}>
            {children}
        </Context_Status_Global.Provider>
    )
}

export function useStatus() {
    return useContext(Context_Status_Global);
}